import { AdjustmentType, AdjustmentTypeText } from 'enums';
import { DropDownButton } from 'components/Buttons/DropDownButton/DropDownButton';

const options = [
    { text: 'All', value: undefined },
    { text: AdjustmentTypeText[AdjustmentType.CustomerDeduction], value: AdjustmentType.CustomerDeduction },
    { text: AdjustmentTypeText[AdjustmentType.DotBillback], value: AdjustmentType.DotBillback }
];

type Props = {
    deductionType: number | undefined,
    onDeductionTypeChange: (value: number | undefined) => void
};

const DeductionCategoryFilter = ({ deductionType, onDeductionTypeChange }: Props) => {
    let displayText = 'All';
    if (deductionType !== undefined) {
        displayText = AdjustmentTypeText[deductionType as AdjustmentType] ?? 'All';
    }

    return (
        <DropDownButton
            items={options}
            onItemClick={(e) => onDeductionTypeChange(e.item.value)}
            text={`Category: ${displayText}`}
            fillMode={'solid'}
            rounded={'small'}
            tabIndex={0}
            size={'small'}
        />
    );
};

export default DeductionCategoryFilter;